<template>
  <div class="flex border-b border-gray-700 mb-4">
    <button
      @click="$emit('change-tab', 'products')"
      class="px-6 py-3 text-sm font-medium transition-colors relative -mb-px"
      :class="[
        activeTab === 'products'
          ? 'text-blue-400 border-b-2 border-blue-400'
          : 'text-gray-400 hover:text-gray-300',
      ]"
    >
      Praćeni proizvodi
    </button>
    <button
      @click="$emit('change-tab', 'users')"
      class="px-6 py-3 text-sm font-medium transition-colors relative -mb-px"
      :class="[
        activeTab === 'users'
          ? 'text-blue-400 border-b-2 border-blue-400'
          : 'text-gray-400 hover:text-gray-300',
      ]"
    >
      Praćeni korisnici
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'FollowingTabs',
  props: {
    activeTab: {
      type: String,
      required: true,
    },
  },
  emits: ['change-tab'],
});
</script>
